import { useMedia } from 'react-use'

import CollectionLandingDesktop from '@/components/sections/collection-landing-desktop'
import CollectionLandingMobile from '@/components/sections/collection-landing-mobile'
import Spacer from '@/components/sections/spacer'

import { WPPageData } from '@/types'

export type CollectionLandingProps = Partial<{
  pageProps: WPPageData & {
    acf?: {
      hero?: {
        title?: string
        text?: string
      }
    }
    collection?: any[]
  }
}>

const CollectionLanding = ({ pageProps, ...props }: CollectionLandingProps) => {
  const isSmall = useMedia('(max-width: 767px)', false)

  const title = pageProps?.acf?.hero?.title
  const text = pageProps?.acf?.hero?.text

  const items = pageProps?.collection

  return (
    <>
      <Spacer variant="xxl" />
      {isSmall ? (
        <CollectionLandingMobile
          title={title}
          text={text}
          items={items}
          {...props}
        />
      ) : (
        <CollectionLandingDesktop
          title={title}
          text={text}
          items={items}
          {...props}
        />
      )}
      <Spacer variant="xxl" />
    </>
  )
}

export default CollectionLanding
